// extracted by mini-css-extract-plugin
export default {"wrapper":"GlowingTree_wrapper__RKWrh","tree":"GlowingTree_tree__ZoL+A","mask":"GlowingTree_mask__Ji9cL"};